// Company data
export const CompanyName = 'Miss Dominatrixa';
export const CompanyPhoneNumber = '07846286385';
export const ContactEmailAddress = 'missdominatrixa@missdominatrixa.com';
export const DirectorName = 'Miss Dominatrixa';
export const ServiceArea = 'EU & Online';
export const AddressLineTwo = 'Across The World';
export const LocationCountry = 'Norway';

export const MainTitle = 'Elite Dominatrix & BDSM Specialist';
export const CompanyTagLine = 'Located in Norway & available across the EU.';
export const SubtitleMain = 'Bringing pleasure to submissives!';

export const KeywordsPages =
  'Miss Dominatrixa, Dominatrix, Dominatrix in EU Norway, BDSM, BDSM EU Norway, EU Norway EU, Femdom, professional dominatrix, dungeon, fetish, submission, Mistress sessions, findom, EU Norway dominatrix, latex dominatrix, pegging, girlfriend experience EU Norway, Miss Dominatrixa, dominatrix, femdom, BDSM, mistress, Norway, Oslo, fetish, financial domination';

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 10000;
export const CookiePolicyName = 'CookiePolicy';

// URL
export const FULL_BUSINESS_URL = 'https://www.missdominatrixa.com';
export const SHORT_BUSINESS_URL = 'missdominatrixa.com';
export const DISPLAY_BUSINESS_URL = 'www.missdominatrixa.com';
export const QuestionaireUrl = '';

export const THRONE_URL = 'https://throne.com/missdominatrixa';
export const FANSLY_URL = 'https://fans.ly/MissDominatrixa';
export const FETLIFE_URL = 'https://fetlife.com/users/3998261';
export const TWITTER_BUSINESS_URL = 'https://x.com/mdominatrixa?s=21';
export const PAYPAL_URL = 'https://www.paypal.me/sivrenate';
export const SNAPCHAT_URL = 'https://snapchat.com/t/VmxJOdpH';

export const CASH_APP_URL = '';
export const APPLE_PAY_EMAIL = '';
export const VENMO_URL = '';
export const WISHLIST_URL = '';
export const ONLYFANS_URL = '';
export const INSTAGRAM_PAGE_URL = '';
export const LOYALFANS_URL = '';
export const TIKTOK_URL = '';
export const YOUPAY_URL = '';
export const SCATBOOK_URL = '';
export const TELEGRAM_URL = '';


// Bot Data
export const BotName = 'Jerry';

// Social Media URLs
export const FACEBOOK_URL = 'https://facebook.com/';
export const INSTAGRAM_URL = 'https://instagram.com/';
export const GOOGLE_URL = 'https://google.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';


